"use client";

import { formatRoomNightsBreakdown } from "../../../_logic/guestroom-nights";
import type { SegmentedRoomNights } from "../../../_types/wizard-types";

interface GuestroomsSummaryProps {
  /** Segmented totals, from `computeSegmentedRoomNights`. */
  summary: SegmentedRoomNights;
}

/**
 * Footer under the guestrooms grid: the program's peak rooms, and room nights split into peak,
 * pre, post, and total (pre/post parts appear only when they hold rooms).
 *
 * @param props - The segmented totals to show.
 * @returns The summary panel.
 */
export function GuestroomsSummary({ summary }: GuestroomsSummaryProps) {
  // Render
  return (
    <dl className="flex flex-col gap-1 rounded-xl bg-indigo-50 px-4 py-3">
      <div className="flex items-center justify-between gap-4">
        <dt className="text-sm font-medium text-indigo-700">Peak rooms</dt>
        <dd className="text-sm font-semibold tabular-nums text-indigo-900">
          {summary.peakRooms.toLocaleString("en-US")}
        </dd>
      </div>
      <div className="flex items-center justify-between gap-4">
        <dt className="text-sm font-medium text-indigo-700">Room nights</dt>
        <dd className="text-sm font-semibold tabular-nums text-indigo-900">{formatRoomNightsBreakdown(summary)}</dd>
      </div>
    </dl>
  );
}
